var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isMobile)?_c('Header'):_vm._e(),(_vm.isMobile)?_c('header-wx'):_vm._e(),_c('div',{class:_vm.isMobile?'mainContentBoxs':'mainContentBox'},[_c('router-view')],1),(!_vm.isMobile)?_c('Footer'):_vm._e(),(_vm.isMobile)?_c('footer-wx'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }